import {
  AutoComplete,
  explodeCSVAndGetObjectsFromLookup,
  useMasterData,
} from '@ui-framework/index';
import { observer } from 'mobx-react';
import { forwardRef } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

const ClaimStatusSelector = forwardRef(({ onChange, ...props }, ref) => {
  const { control } = useFormContext();

  const statusList = useMasterData().claimStatuses;
  const sendAsTargetValue = newValue => ({
    target: { name: props?.name, value: newValue },
  });

  const loadOptions = async (searchValue, callback) => {
    const data = statusList.filter(opt =>
      (opt?.label ?? '')
        .toLowerCase()
        .includes((searchValue || '').toLowerCase()),
    );
    return callback(data);
  };

  return (
    <Controller
      control={control}
      name={props?.name}
      render={({ field }) => {
        const newValues = explodeCSVAndGetObjectsFromLookup(
          field.value,
          statusList,
        );
        return (
          <AutoComplete
            ref={ref}
            {...field}
            {...props}
            loadOptions={loadOptions}
            isMulti
            defaultOptions={statusList}
            overwriteProps={{
              value: newValues,
              onChange: e => {
                if (Array.isArray(e) && e.length > 0) {
                  field.onChange(
                    sendAsTargetValue(e.map(ev => ev.value).join(',')),
                  );
                } else {
                  field.onChange(sendAsTargetValue(null));
                }
              },
            }}
          />
        );
      }}
    />
  );
});

export default observer(ClaimStatusSelector);
